/**
 * Home Page
 * Step 1 in funnel
 */
import React, { useRef, useState, useCallback } from 'react';
import { useNavigate } from "react-router-dom"; 
import { useSelector, useDispatch } from 'react-redux';
import { AppBar, Toolbar, Typography, Box, TextField, Button, Container } from '@mui/material';
import { LoadScript, StandaloneSearchBox } from '@react-google-maps/api';

import Header from '../../components/Header';
import MAP from '../../components/Map';
import { GOOGLE_MAPS_API_KEY } from '../../common/constants';
import { set } from 'lodash';

const HomePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const searchBoxRef = useRef(null);

  const [mapCenter, setMapCenter] = useState({ lat: 49.5, lng: -100 });
  const [mapZoom, setMapZoom] = useState(5);

  const handleOnPlacesChanged = () => {
    const places = searchBoxRef.current.getPlaces();
    if (places && places.length > 0) {
      const place = places[0];
      console.log('Selected place:', place);
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      const name = place.name;
      const address = place.formatted_address;

      setMapCenter({ lat, lng });
      if (mapZoom !== 9) {
        setMapZoom(9);
      }
    }
  }

  const handleSubmit = () => {
    // Navigate to the next page
    navigate('/app/treatment');
  }

  return (
    <Box >
      {/* Map */}
      <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0 }}>
        <MAP
          mapContainerStyle={{ width: '100%', height: '100%' }}
          newCenter={mapCenter}
          newZoom={mapZoom}
          mapOptions={{
            disableDefaultUI: true,
            gestureHandling: 'none',
            keyboardShortcuts: false,
            draggable: false,
            scrollwheel: false,
            disableDoubleClickZoom: true,
          }}
          zoomOverlay={false}  // disable zoom overlay on home page
        />
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            bgcolor: 'rgba(0, 0, 0, 0.15)', // optional gray/white overlay
          }}
        />
      </Box>

      {/* Centered Search */}
      <Box
        sx={{
          zIndex: 1,
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'rgba(255, 255, 255, 0.65)',
          padding: 4,
          borderRadius: 2,
          boxShadow: 3,
          textAlign: 'center',
          width: '90%',
          maxWidth: 500,
        }}
      >
        <Typography variant="h5" gutterBottom>
          Search for an area of interest
        </Typography>
        <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY} libraries={['places']}>
          <StandaloneSearchBox
            onLoad={(ref) => (searchBoxRef.current = ref)}
            onPlacesChanged={handleOnPlacesChanged}
          >
            <TextField
              placeholder="Search for a location"
              variant="outlined"
              fullWidth
              inputRef={(input) => {
                if (input) {
                  // Attach to DOM input element
                  const nativeInput = input.querySelector('input');
                  if (nativeInput) {
                    nativeInput.setAttribute('id', 'search-box');
                  }
                }
              }}
              sx={{ mb: 2 }}
            />
          </StandaloneSearchBox>
        </LoadScript>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={() => {
            handleSubmit();
          }}
        >
          Find Treatment Wells
        </Button>
      </Box>
    </Box>
  );
};

export default HomePage;
